import React, { useState } from "react";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

export type DateRangeType = {
  startDate: any;
  endDate: any;
};

type DateRangeSelectorProps = {
  initialRange?: DateRangeType;
  onChange: (range: DateRangeType) => void;
  className?: string;
};

const normalizeRange = (range: [Date | null, Date | null]): DateRangeType => {
  const [start, end] = range;

  const normalizedStart = start
    ? new Date(start.setHours(0, 0, 0, 0)) // Set time to 12:00 AM
    : null;

  const normalizedEnd = end
    ? new Date(end.setHours(23, 59, 59, 999)) // Set time to 11:59 PM
    : null;

  return { startDate: normalizedStart, endDate: normalizedEnd };
};

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  initialRange = { startDate: null, endDate: null },
  onChange,
  className = "",
}) => {
  const [range, setRange] = useState<[Date | null, Date | null]>([
    initialRange.startDate,
    initialRange.endDate,
  ]);

  const handleDateChange = (value: [Date | null, Date | null] | null) => {
    if (value) {
      const normalized = normalizeRange(value);
      setRange([normalized.startDate, normalized.endDate]);
      onChange(normalized);
    } else {
      setRange([null, null]);
      onChange({ startDate: null, endDate: null });
    }
  };

  return (
    <div className={className}>
      <DateRangePicker
        value={range[0] && range[1] ? (range as [Date, Date]) : null}
        onChange={handleDateChange}
        placeholder="startDate - endDate"
        className="z-10"
        cleanable
        format="yyyy-MM-dd"
      />
    </div>
  );
};

export default DateRangeSelector;
